// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const DEFAULT_WIDTH_COLUMN_TEXT = 150;
const DEFAULT_WIDTH_COLUMN_ICON = 50;

export default {
  DEFAULT_ROW_HEIGHT: 31,
  DEFAULT_ROW_HEIGHT_HEADER: 41,
  DEFAULT_TABLE_HEIGHT: 775,
  DEFAULT_REST_HEIGHT: 36,

  get TableDefinition() {
    return {
      get ImportHistorySourceType() {
        return {
          select: {
            key: 'select',
            columnKey: 'Select',
            width: DEFAULT_WIDTH_COLUMN_ICON,
            resizable: false,
            title: '',
            sortable: false
          },
          fileName: {
            key: 'fileName',
            columnKey: 'FileName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_FILENAME');
            },
            sortable: true
          },
          typeName: {
            key: 'typeName',
            columnKey: 'TypeName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_TYPE');
            },
            sortable: true
          },
          modified: {
            key: 'modified',
            columnKey: 'Modified',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_IMPORTED_DATE');
            },
            sortable: true
          },
          modifiedBy: {
            key: 'modifiedBy',
            columnKey: 'ModifiedBy',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_IMPORTER');
            },
            sortable: true
          },
          statusName: {
            key: 'statusName',
            columnKey: 'StatusName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_IMPORT_STATUS');
            },
            sortable: true
          },
          errorMessage: {
            key: 'errorMessage',
            columnKey: 'ErrorMessage',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_FAILURE_ERROR');
            },
            sortable: true
          },
          objectName: {
            key: 'objectName',
            columnKey: 'ObjectName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_REPORT_OR_DASHBOARD_NAME');
            },
            sortable: true
          },
          saveInto: {
            key: 'saveInto',
            columnKey: 'SaveInto',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SAVE_INTO');
            },
            sortable: true
          },
          categoryName: {
            key: 'categoryName',
            columnKey: 'CategoryName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_CATEGORY');
            },
            sortable: true
          },
          subCategoryName: {
            key: 'subCategoryName',
            columnKey: 'SubCategoryName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SUB_CATEGORY');
            },
            sortable: true
          },
          action: {
            key: 'action',
            columnKey: 'Action',
            width: DEFAULT_WIDTH_COLUMN_ICON,
            resizable: false,
            title: '',
            sortable: false
          }
        };
      }
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ImportHistoryConstants.js